export default {
  titles: {
    main: 'Meine Tischmitglieder',
    no_members: 'Personen, die deiner Gruppe beitreten, werden hier aufgelistet',
  },
  buttons: {
    leave_party: 'Doch nicht vom Handy bestellen? Klick hier um den Tisch zu verlassen →',
  },
};